import Intro from "../../assets/intro.png";
import Business from "../../assets/img/business/business-img.png";
import Footer from "../../components/footer";

import { useState } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import CardProduct from "./components/card";
// import { Button } from "../../components/ui/button";
import { LogInIcon } from "lucide-react";
import ImageSlider from "../../components/slider";

import {
	ArrowRight,
	BarChart3,
	Cloud,
	Filter,
	HeadphonesIcon,
	ShieldCheck,
	Smartphone,
	Target,
	Star,
	HelpCircle,
	CheckCircle2,
	ChevronDown,
} from "lucide-react";

const linkWhatsApp = (texto) => `https://wa.me/5516992717337?text=${encodeURIComponent(texto)}`;

function Home() {
	const navigate = useNavigate();
	const [openFaq, setOpenFaq] = useState(null);

	const faqs = [
		{
			q: "Como funciona o suporte técnico?",
			a: "Nosso suporte funciona em horário comercial via WhatsApp e Telefone. Nossa equipe de especialistas avalia seu problema remotamente e resolve de forma rápida para que a sua loja não pare de faturar.",
		},
		{
			q: "O sistema funciona se a internet cair?",
			a: "Sim! Trabalhamos com PDV híbrido. Caso você perca a conexão, você continua registrando vendas e emitindo cupons (offline) normalmente. Assim que a rede retornar, o sistema consolida e envia tudo para a nuvem de forma automática.",
		},
		{
			q: "Preciso de equipamentos novos ou específicos?",
			a: "Na maioria dos casos, não! O SZ PDV é flexível e compatível com 99% das impressoras térmicas (EPSON, Elgin, Bematech, etc), leitores de código de barra e gavetas de dinheiro do mercado.",
		},
		{
			q: "A migração do meu sistema antigo é tarifada?",
			a: "A equipe técnica do SZ faz a migração de seus cadastros (Produtos, Clientes, Fornecedores) de forma gratuita se você conseguir extraí-los em planilhas Excel/CSV do seu sistema antigo.",
		},
		{
			q: "Posso acessar relatórios da minha loja pelo celular?",
			a: "Completamente. Como o sistema fica em nuvem, você como gestor ou empresário pode acessar o dashboard, fechamento de caixas e até fazer alterações em produtos de qualquer dispositivo.",
		},
		{
			q: "Qual é o tempo de fidelidade do contrato?",
			a: "Não exigimos fidelidade e nem cobramos multa recisória. O nosso compromisso é com a qualidade. Acreditamos que o lojista deve ficar porque gosta e precisa da plataforma, não porque há uma amarra contratual.",
		},
	];

	const toggleFaq = (index) => {
		setOpenFaq(openFaq === index ? null : index);
	};

	const scrollToPlanos = () => {
		const planosSection = document.getElementById("nossos-planos");
		if (planosSection) {
			planosSection.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<div className="min-h-screen flex flex-col font-sans bg-gray-50 antialiased">
			{/* Navbar Profissional (Fixa) */}
			<header className="w-full bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
					{/* Logo Textual Moderno (Estilo SaaS Premium) */}
					<div
						className="flex-shrink-0 flex items-center gap-2 cursor-pointer group"
						onClick={() => navigate("/")}
					>
						{/* Ícone/Badge */}
						<div className="bg-gradient-to-br from-blue-600 to-blue-900 text-white w-9 h-9 rounded-xl shadow-[0_4px_10px_-2px_rgba(37,99,235,0.4)] flex items-center justify-center transform transition-all group-hover:scale-105 group-hover:-translate-y-0.5 relative z-10 overflow-hidden">
							<span className="font-extrabold text-xl leading-none tracking-tight translate-z-0 drop-shadow-sm px-1 mt-0.5">
								SZ
							</span>
						</div>

						{/* Textos */}
						<div className="hidden sm:flex flex-col justify-center antialiased">
							<span className="font-black text-xl leading-none text-gray-900 tracking-tight">
								Sistemas
							</span>
							<span className="text-[10px] font-bold text-blue-600 tracking-widest uppercase leading-none mt-1">
								Gestão Inteligente
							</span>
						</div>
					</div>

					<nav className="hidden md:flex gap-8 items-center">
						<button
							onClick={scrollToPlanos}
							className="text-gray-600 hover:text-blue-600 font-medium transition-colors"
						>
							Planos
						</button>
						<a
							href="#funcionalidades"
							className="text-gray-600 hover:text-blue-600 font-medium transition-colors"
						>
							Funcionalidades
						</a>
						<a href="#contato" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
							Fale Conosco
						</a>
					</nav>

					<div className="flex gap-4 items-center">
						<button
							className="flex items-center justify-center bg-blue-700 hover:bg-blue-800 text-white font-medium rounded-md px-5 py-2 transition shadow-sm gap-2"
							onClick={() => navigate("/login")}
						>
							<LogInIcon size={18} />
							<span>Acessar Sistema</span>
						</button>
					</div>
				</div>
			</header>

			{/* Hero Section */}
			<section className="relative bg-gradient-to-b from-blue-900 to-blue-800 text-white overflow-hidden py-24 sm:py-32">
				<div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>

				<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
					<div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-800/50 border border-blue-400/30 text-blue-100 text-sm font-medium mb-8">
						<span className="flex h-2 w-2 rounded-full bg-green-400"></span>
						Sistema de Gestão 100% em Nuvem
					</div>

					<h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 max-w-4xl">
						Revolucione a gestão do seu <span className="text-blue-300">PDV</span> e impulsione suas vendas.
					</h1>

					<p className="text-lg sm:text-xl text-blue-100 mb-10 max-w-2xl">
						Software completo, rápido e intuitivo para o seu comércio. Controle de estoque, emissão fiscal,
						financeiro simplificado e relatórios automáticos. Tudo em um só lugar.
					</p>

					<div className="flex gap-4 flex-col sm:flex-row w-full sm:w-auto">
						<button
							onClick={scrollToPlanos}
							className="bg-white text-blue-900 hover:bg-gray-50 font-bold px-8 py-4 rounded-lg shadow-lg transition-all flex items-center justify-center gap-2 transform hover:-translate-y-1"
						>
							Conhecer os Planos
							<ArrowRight size={18} />
						</button>
						<a
							href={linkWhatsApp("Olá! Vim pelo site e quero agendar uma demonstração do sistema.")}
							target="_blank"
							rel="noopener noreferrer"
							className="bg-blue-800 hover:bg-blue-700 border border-blue-400/50 text-white font-semibold px-8 py-4 rounded-lg shadow-sm transition-colors text-center"
						>
							Agendar Demonstração
						</a>
					</div>
				</div>
			</section>

			{/* Secao de Recursos / Benefícios */}
			<section id="funcionalidades" className="py-20 bg-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center mb-16">
						<h2 className="text-3xl font-bold text-gray-900 mb-4">Tudo o que você precisa para crescer</h2>
						<p className="text-lg text-gray-600 max-w-2xl mx-auto">
							Mais do que um sistema de vendas. Entregamos as ferramentas necessárias para
							profissionalizar e organizar a sua operação diária.
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
						{/* Card 1 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<Cloud size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">100% em Nuvem</h3>
							<p className="text-gray-600">
								Acesse seu sistema de qualquer lugar, a qualquer hora. Seus dados ficam seguros em
								servidores de alta disponibilidade e salvos automaticamente.
							</p>
						</div>

						{/* Card 2 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<Filter size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">Estoque Inteligente</h3>
							<p className="text-gray-600">
								Receba alertas de curva ABC, acompanhe movimentações de inventário em tempo real e nunca
								mais perca vendas por falta de mercadoria.
							</p>
						</div>

						{/* Card 3 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<BarChart3 size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">Métricas e Relatórios</h3>
							<p className="text-gray-600">
								Entenda a saúde financeira da sua loja. Visualizações analíticas, fechamento de caixa,
								curva de vendas e balanço financeiro e muito mais.
							</p>
						</div>

						{/* Card 4 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<ShieldCheck size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">Emissão Fiscal Segura</h3>
							<p className="text-gray-600">
								Emita notas fiscais (NFC-e, NFe, CF-e) de forma rápida e segura. Conte com cálculos
								automáticos validados com a secretaria da fazenda.
							</p>
						</div>

						{/* Card 5 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<Smartphone size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">Multi-dispositivos</h3>
							<p className="text-gray-600">
								Nosso sistema funciona em computadores, tablets (iPads, Androids) e smartphones para as
								mais diversas realidades operacionais.
							</p>
						</div>

						{/* Card 6 */}
						<div className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
							<div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center mb-6">
								<Target size={24} />
							</div>
							<h3 className="text-xl font-bold text-gray-900 mb-3">Múltiplas Lojas</h3>
							<p className="text-gray-600">
								Tem mais de um CNPJ? Centralize o controle de clientes, gerencie permissões de
								colaboradores e unifique dados financeiros em um único parceiro.
							</p>
						</div>
					</div>
				</div>
			</section>

			{/* Nossos Planos (Reutilização do CardProduct) */}
			<section id="nossos-planos" className="py-20 bg-gray-50 border-t border-gray-200">
				<div className="max-w-7xl mx-auto pt-4 pb-12">
					<div className="text-center mb-8">
						<h2 className="text-3xl font-bold text-gray-900 mb-4">Planos que cabem no seu orçamento</h2>
						<p className="text-lg text-gray-600 max-w-2xl mx-auto">
							Diferentes tamanhos, diferentes modelos de negócio. Escolha a versão que melhor atende à sua
							empresa no momento.
						</p>
					</div>

					{/* CardProduct - Modulos via API */}
					<CardProduct />
				</div>
			</section>

			{/* Depoimentos de Clientes (Social Proof) */}
			<section className="py-20 bg-blue-900 text-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center mb-16">
						<h2 className="text-3xl font-bold mb-4">O que nossos clientes dizem</h2>
						<p className="text-lg text-blue-200 max-w-2xl mx-auto">
							Milhares de empreendedores confiam no SZ PDV para gerenciar suas empresas todos os dias.
							Veja algumas das experiências reais com o nosso sistema.
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
						{/* Depoimento 1 */}
						<div className="bg-blue-800/50 p-8 rounded-2xl border border-blue-700/50 relative transition hover:-translate-y-1 hover:shadow-lg">
							<div className="flex text-yellow-400 mb-4 gap-1">
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
							</div>
							<p className="text-blue-50 italic mb-6">
								"Desde que implantamos o sistema, nosso controle de estoque ficou 100% preciso. A
								emissão de notas fiscais que antes era uma dor de cabeça, agora sai em questão de
								segundos."
							</p>
							<div className="flex items-center gap-4 mt-auto">
								<div className="h-12 w-12 rounded-full bg-blue-600 flex items-center justify-center font-bold text-lg shadow-inner">
									CM
								</div>
								<div>
									<h4 className="font-bold text-white leading-tight">Carlos Mendes</h4>
									<p className="text-sm text-blue-300">Proprietário de Supermercado</p>
								</div>
							</div>
						</div>

						{/* Depoimento 2 */}
						<div className="bg-blue-800/50 p-8 rounded-2xl border border-blue-700/50 relative transition hover:-translate-y-1 hover:shadow-lg">
							<div className="flex text-yellow-400 mb-4 gap-1">
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
							</div>
							<p className="text-blue-50 italic mb-6">
								"O suporte é fenomenal. Tínhamos muita dificuldade com sistemas complexos antes e o SZ
								PDV trouxe logo de cara a agilidade que nossos vendedores precisavam. Recomendo de olhos
								fechados!"
							</p>
							<div className="flex items-center gap-4 mt-auto">
								<div className="h-12 w-12 rounded-full bg-green-600 flex items-center justify-center font-bold text-lg shadow-inner">
									AL
								</div>
								<div>
									<h4 className="font-bold text-white leading-tight">Ana Lúcia</h4>
									<p className="text-sm text-blue-300">Gerente de Loja de Roupas</p>
								</div>
							</div>
						</div>

						{/* Depoimento 3 */}
						<div className="bg-blue-800/50 p-8 rounded-2xl border border-blue-700/50 relative transition hover:-translate-y-1 hover:shadow-lg">
							<div className="flex text-yellow-400 mb-4 gap-1">
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
								<Star size={18} fill="currentColor" />
							</div>
							<p className="text-blue-50 italic mb-6">
								"O diferencial pra mim é o sistema ser totalmente na nuvem. Posso acompanhar o
								fechamento de caixa e as vendas em tempo real direto do meu celular, sem precisar estar
								lá na loja física naquele dia."
							</p>
							<div className="flex items-center gap-4 mt-auto">
								<div className="h-12 w-12 rounded-full bg-orange-500 flex items-center justify-center font-bold text-lg shadow-inner">
									RS
								</div>
								<div>
									<h4 className="font-bold text-white leading-tight">Roberto Silva</h4>
									<p className="text-sm text-blue-300">Dono de Franquia (3 Lojas)</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Garantia / Risco Zero */}
			<section className="py-16 bg-blue-50">
				<div className="max-w-4xl mx-auto px-6 text-center">
					<div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 text-blue-600 rounded-full mb-6">
						<CheckCircle2 size={40} />
					</div>
					<h2 className="text-3xl font-bold text-gray-900 mb-4">Teste sem compromisso</h2>
					<p className="text-lg text-gray-600 mb-8">
						Sabemos que mudar de sistema pode dar receio. Por isso, oferecemos um período de teste gratuito
						para você validar na prática como o SZ PDV simplifica a sua vida, sem precisar cadastrar cartão
						de crédito.
					</p>
					<button
						onClick={() => navigate("/login")}
						className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-10 rounded-xl shadow-lg transition-transform hover:-translate-y-1"
					>
						Criar Minha Conta Grátis
					</button>
				</div>
			</section>

			{/* FAQ - Perguntas Frequentes */}
			<section id="faq" className="py-20 bg-white border-t border-gray-100">
				<div className="max-w-4xl mx-auto px-6">
					<div className="text-center mb-16">
						<h2 className="text-3xl font-bold text-gray-900 mb-4">Perguntas Frequentes</h2>
						<p className="text-gray-600 font-medium text-lg">
							Tire suas dúvidas e veja como é simples migrar para o SZ PDV.
						</p>
					</div>

					<div className="space-y-4">
						{faqs.map((faq, index) => {
							const isOpen = openFaq === index;
							return (
								<div
									key={index}
									className={`border rounded-2xl transition-all duration-300 ${isOpen ? "bg-white border-blue-200 shadow-md" : "bg-gray-50 border-gray-100 hover:border-blue-200"}`}
								>
									<button
										onClick={() => toggleFaq(index)}
										className="w-full text-left p-6 flex items-start justify-between gap-4 focus:outline-none"
									>
										<h3
											className={`text-lg font-bold flex items-center gap-3 ${isOpen ? "text-blue-700" : "text-gray-900"}`}
										>
											<HelpCircle
												className={isOpen ? "text-blue-600 shrink-0" : "text-gray-400 shrink-0"}
												size={20}
											/>
											{faq.q}
										</h3>
										<div
											className={`mt-0.5 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0 text-gray-400"}`}
										>
											<ChevronDown size={20} />
										</div>
									</button>

									<div
										className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
									>
										<p className="text-gray-600 pb-6 pr-6 pl-14 leading-relaxed">{faq.a}</p>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</section>

			{/* CTA Final */}
			<div id="contato" className="bg-blue-600 text-white py-16">
				<div className="max-w-5xl mx-auto px-6 text-center">
					<h2 className="text-3xl font-bold mb-4">Ainda com dúvidas de qual sistema escolher?</h2>
					<p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
						Fale direto com nossos especialistas. Avaliaremos o seu cenário juntos e apresentaremos soluções
						diretas pro seu negócio rodar melhor!
					</p>
					<div className="flex justify-center gap-4 flex-col sm:flex-row">
						<a
							href={linkWhatsApp("Olá! Vim pelo site e quero falar com um especialista.")}
							target="_blank"
							rel="noopener noreferrer"
							className="bg-white text-blue-700 hover:bg-gray-100 font-bold py-3 px-8 rounded-md shadow-lg transition-transform hover:-translate-y-1 inline-flex justify-center items-center gap-2"
						>
							<HeadphonesIcon size={20} />
							Falar no WhatsApp
						</a>
					</div>
				</div>
			</div>

			{/* Rodapé Moderno */}
			<footer className="bg-gray-900 text-gray-400 py-12 mt-auto border-t-4 border-blue-600">
				<div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
					<div className="col-span-1 lg:col-span-1">
						<h3 className="text-white font-bold text-xl mb-4 flex items-center gap-2">SZ Sistemas</h3>
						<p className="text-sm text-gray-500 mb-4 pr-4">
							A solução completa e inteligente para escalar as vendas e simplificar a gestão da sua
							empresa.
						</p>
					</div>
					<div>
						<h4 className="font-semibold text-white mb-4">O Sistema</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<a href="#funcionalidades" className="hover:text-blue-400 transition">
									Funcionalidades
								</a>
							</li>
							<li>
								<a href="#nossos-planos" className="hover:text-blue-400 transition">
									Assinaturas
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-blue-400 transition">
									Recursos Essenciais
								</a>
							</li>
						</ul>
					</div>
					<div>
						<h4 className="font-semibold text-white mb-4">Atendimento</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<a href="#" className="hover:text-blue-400 transition">
									Central de Ajuda
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-blue-400 transition">
									Documentação Oficial
								</a>
							</li>
							<li>
								<a
									href={linkWhatsApp("Olá! Vim pelo site e gostaria de mais informações.")}
									target="_blank"
									rel="noopener noreferrer"
									className="hover:text-blue-400 transition"
								>
									Chamar via WhatsApp
								</a>
							</li>
						</ul>
					</div>
					<div>
						<h4 className="font-semibold text-white mb-4">Institucional</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<a href="#" className="hover:text-blue-400 transition">
									Quem Somos
								</a>
							</li>
							<li>
								<Link to="/termos-de-uso" className="hover:text-blue-400 transition">
									Termos de Uso
								</Link>
							</li>
							<li>
								<Link to="/politica-de-privacidade" className="hover:text-blue-400 transition">
									Política de Privacidade
								</Link>
							</li>
						</ul>
					</div>
				</div>
				<div className="max-w-7xl mx-auto px-6 border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
					<p>© {new Date().getFullYear()} - SZ Sistemas. Todos os direitos reservados.</p>
					<div className="mt-4 md:mt-0 flex gap-4">
						{/* Ícones de midias sociais iriam aqui */}
						<span className="text-xs tracking-wider uppercase text-gray-600">
							Feito para Empreendedores
						</span>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default Home;
